var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-card",
    { staticClass: "hide-overflow", attrs: { flat: "", height: "100%" } },
    [
      _c(
        "Loading",
        {
          attrs: {
            visible: _vm.loading,
            message: "Caricamento spedizioni...",
            templateType: _vm.loadTemplateCorrente,
          },
        },
        [
          _c(
            "v-layout",
            { staticStyle: { "margin-bottom": "50px" }, attrs: { wrap: "" } },
            [
              _vm.userIsAdmin
                ? _c(
                    "v-flex",
                    {
                      staticStyle: { margin: "24px 24px 0px 24px" },
                      attrs: { xs12: "" },
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          filled: "",
                          clearable: "",
                          "return-object": "",
                          items: _vm.fornitori,
                          "item-text": "nome",
                          label: "Fornitori",
                          hint: "Selezionare fornitore per visualizzare le spedizioni",
                        },
                        model: {
                          value: _vm.fornitore,
                          callback: function ($$v) {
                            _vm.fornitore = $$v
                          },
                          expression: "fornitore",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-btn",
                {
                  staticStyle: {
                    color: "white",
                    "margin-top": "10px",
                    "margin-left": "24px",
                    "margin-bottom": "10px",
                  },
                  attrs: { color: "green lighten-2" },
                  on: {
                    click: function ($event) {
                      _vm.newSpedizioneDialogVisible = true
                    },
                  },
                },
                [
                  _vm._v(" Nuova "),
                  _c("v-icon", { attrs: { right: "" } }, [_vm._v("mdi-plus")]),
                ],
                1
              ),
              _c(
                "v-bottom-sheet",
                {
                  attrs: { "hide-overlay": "", inset: "" },
                  model: {
                    value: _vm.newSpedizioneDialogVisible,
                    callback: function ($$v) {
                      _vm.newSpedizioneDialogVisible = $$v
                    },
                    expression: "newSpedizioneDialogVisible",
                  },
                },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-card-title",
                        {
                          staticClass: "headline d-flex justify-space-between",
                        },
                        [
                          _vm._v("Nuova spedizione "),
                          _c(
                            "v-icon",
                            {
                              on: {
                                click: function ($event) {
                                  _vm.newSpedizioneDialogVisible = false
                                },
                              },
                            },
                            [_vm._v("mdi-close")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-row",
                            { staticClass: "flex" },
                            [
                              _c("v-text-field", {
                                staticClass: "col-4",
                                attrs: { label: "Numero spedizione" },
                                model: {
                                  value: _vm.newSpedizione.numeroDDT,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.newSpedizione,
                                      "numeroDDT",
                                      $$v
                                    )
                                  },
                                  expression: "newSpedizione.numeroDDT",
                                },
                              }),
                              _c("v-text-field", {
                                staticClass: "col-4",
                                attrs: {
                                  label: "Numero colli",
                                  type: "number",
                                },
                                model: {
                                  value: _vm.newSpedizione.numeroColli,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.newSpedizione,
                                      "numeroColli",
                                      $$v
                                    )
                                  },
                                  expression: "newSpedizione.numeroColli",
                                },
                              }),
                              _c(
                                "v-menu",
                                {
                                  ref: "newSpedizioneDateMenu",
                                  attrs: {
                                    "offset-y": "",
                                    transition: "scale-transition",
                                    "close-on-content-click": false,
                                    "max-width": "290px",
                                    "min-width": "90px",
                                    "nudge-right": 40,
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function ({ on }) {
                                        return [
                                          _c(
                                            "v-text-field",
                                            _vm._g(
                                              {
                                                staticClass: "col-4",
                                                attrs: {
                                                  label: "Data spedizione",
                                                  "persistent-hint": "",
                                                  "prepend-icon":
                                                    "mdi-calendar",
                                                },
                                                on: {
                                                  blur: function ($event) {
                                                    _vm.newSpedizioneDataSpedizione =
                                                      _vm.parseDate(
                                                        _vm.newSpedizioneDataSpedizioneFormatted
                                                      )
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.newSpedizioneDataSpedizioneFormatted,
                                                  callback: function ($$v) {
                                                    _vm.newSpedizioneDataSpedizioneFormatted =
                                                      $$v
                                                  },
                                                  expression:
                                                    "newSpedizioneDataSpedizioneFormatted",
                                                },
                                              },
                                              on
                                            )
                                          ),
                                        ]
                                      },
                                    },
                                  ]),
                                  model: {
                                    value: _vm.newSpedizioneDateMenu,
                                    callback: function ($$v) {
                                      _vm.newSpedizioneDateMenu = $$v
                                    },
                                    expression: "newSpedizioneDateMenu",
                                  },
                                },
                                [
                                  _c("v-date-picker", {
                                    on: {
                                      input: function ($event) {
                                        _vm.newSpedizioneDateMenu = false
                                      },
                                    },
                                    model: {
                                      value: _vm.newSpedizioneDataSpedizione,
                                      callback: function ($$v) {
                                        _vm.newSpedizioneDataSpedizione = $$v
                                      },
                                      expression: "newSpedizioneDataSpedizione",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            { staticClass: "flex justify-space-around" },
                            [
                              _c("v-textarea", {
                                staticClass: "col-12",
                                attrs: {
                                  name: "new-spedizione-note",
                                  label: "Note",
                                },
                                model: {
                                  value: _vm.newSpedizione.note,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newSpedizione, "note", $$v)
                                  },
                                  expression: "newSpedizione.note",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            { staticClass: "flex justify-center" },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "success" },
                                  on: { click: _vm.creaSpedizione },
                                },
                                [_vm._v("Salva")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c(
                    "v-tabs",
                    {
                      attrs: {
                        dark: "",
                        "slider-color": "yellow",
                        "slider-size": "5",
                        "show-arrows": "",
                      },
                      model: {
                        value: _vm.filtroStatoSpedizioni,
                        callback: function ($$v) {
                          _vm.filtroStatoSpedizioni = $$v
                        },
                        expression: "filtroStatoSpedizioni",
                      },
                    },
                    [
                      _c("v-tab", [_vm._v(" TUTTE ")]),
                      _vm._l(_vm.stati, function (stato) {
                        return _c(
                          "v-tab",
                          { key: stato, attrs: { "data-test": stato } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm._f("statoSpedizioneDesc")(stato)) +
                                " "
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm.spedizioni && _vm.spedizioni.length > 0
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      !_vm.vistaLista
                        ? _c("SpedizioniCards", {
                            attrs: { spedizioni: _vm.spedizioni },
                          })
                        : _c("SpedizioniList", {
                            attrs: { spedizioni: _vm.spedizioni },
                          }),
                      _c(
                        "v-dialog",
                        {
                          attrs: { "hide-overlay": "", width: "800" },
                          model: {
                            value: _vm.showDeleteSpedizioneDialog,
                            callback: function ($$v) {
                              _vm.showDeleteSpedizioneDialog = $$v
                            },
                            expression: "showDeleteSpedizioneDialog",
                          },
                        },
                        [
                          _c(
                            "v-card",
                            [
                              _c(
                                "v-card-title",
                                {
                                  staticClass:
                                    "headline d-flex justify-space-between",
                                },
                                [
                                  _vm._v(" Elimina spedizione "),
                                  _c(
                                    "v-icon",
                                    {
                                      on: {
                                        click: function ($event) {
                                          _vm.idSpedizioneForDelete = null
                                        },
                                      },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-card-text",
                                [
                                  _c("v-row", { staticClass: "ma-5" }, [
                                    _vm.selectedSpedizione.numeroDDT
                                      ? _c("h2", [
                                          _vm._v(
                                            " Vuoi eliminare la spedizione numero " +
                                              _vm._s(
                                                _vm.selectedSpedizione.numeroDDT
                                              ) +
                                              " "
                                          ),
                                          _vm.selectedSpedizione.dataDDT
                                            ? _c("span", [
                                                _vm._v(
                                                  " del " +
                                                    _vm._s(
                                                      _vm._f("formatDate")(
                                                        _vm.selectedSpedizione
                                                          .dataDDT
                                                      )
                                                    )
                                                ),
                                              ])
                                            : _vm._e(),
                                          _vm._v("?"),
                                        ])
                                      : _c("h2", [
                                          _vm._v(
                                            " Vuoi eliminare spedizione con id " +
                                              _vm._s(
                                                _vm.selectedSpedizione.id
                                              ) +
                                              "?"
                                          ),
                                        ]),
                                  ]),
                                  _c(
                                    "v-row",
                                    { staticClass: "flex justify-center" },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "mr-2",
                                          attrs: { color: "success" },
                                          on: { click: _vm.deleteSpedizione },
                                        },
                                        [_vm._v("Sì")]
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { color: "secondary" },
                                          on: {
                                            click: function ($event) {
                                              _vm.idSpedizioneForDelete = null
                                            },
                                          },
                                        },
                                        [_vm._v("No")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c(
                        "v-alert",
                        {
                          staticStyle: { margin: "auto" },
                          attrs: { type: "info", value: true },
                        },
                        [_vm._v("Non ci sono spedizioni da visualizzare.")]
                      ),
                    ],
                    1
                  ),
              _c("div", { staticClass: "pagination text-xs-center" }, [
                _c("div", { staticClass: "pagination-text grey--text" }, [
                  _vm._v(" Spedizioni visualizzate: "),
                  _c("strong", [_vm._v(_vm._s(_vm.numTotSpedizioni))]),
                ]),
                _c(
                  "div",
                  { staticClass: "pagination-buttons" },
                  [
                    _c("v-pagination", {
                      attrs: { length: _vm.pageCount, disabled: _vm.loading },
                      model: {
                        value: _vm.page,
                        callback: function ($$v) {
                          _vm.page = $$v
                        },
                        expression: "page",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }